import type { Descendant } from 'slate';

import { SLATE_TEXT_FORMATS, type SlateTextFormat } from './const';
import type { CustomSlateElement, CustomSlateLeaf } from './types';

export const createBlockNode = (
  type: SlateTextFormat,
  children: Descendant[],
  props = {}
): CustomSlateElement => ({
  type,
  children,
  ...props,
});

export const createTextNode = (text: string = '', props = {}): CustomSlateLeaf => ({
  text,
  ...props,
});

export const createParagraph = (children: Descendant[]): CustomSlateElement =>
  createBlockNode(SLATE_TEXT_FORMATS.PARAGRAPH, children);
export const createTextParagraph = (text: string = '', props = {}): CustomSlateElement =>
  createParagraph([createTextNode(text, props)]);

export const createBulletedListNode = (children: Descendant[]): CustomSlateElement =>
  createBlockNode(SLATE_TEXT_FORMATS.BULLETED_LIST, children);

export const createListItemNode = (text: string = ''): CustomSlateElement =>
  createBlockNode(SLATE_TEXT_FORMATS.LIST_ITEM, [createTextNode(text)]);

export const createLinkNode = ({
  url,
  text = '',
}: {
  url: string;
  text?: string;
}): CustomSlateElement => createBlockNode(SLATE_TEXT_FORMATS.LINK, [createTextNode(text)], { url });

export const createImageNode = ({ src }: { src: string }): CustomSlateElement =>
  createBlockNode(SLATE_TEXT_FORMATS.IMG, [createTextNode()], { src });

export const createBlockQuote = ({ text }: { text: string }): CustomSlateElement =>
  createBlockNode(SLATE_TEXT_FORMATS.BLOCK_QUOTE, [createTextNode(text)]);

export const convertStringWithLineBreaksToParagraphs = (str: string) => {
  return str.split('\n').map((text) => createTextParagraph(text));
};

export const createLineBreak = () => {
  return createTextParagraph();
};
